"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = __importDefault(require("../../design/colors"));
const constants_1 = require("../../config/constants");
const reactstrap_1 = require("reactstrap");
const drop_down_component_1 = __importDefault(require("../common/drop-down.component"));
exports.fadeIn = styled_components_1.keyframes `
0% {
  opacity: 0;
}
100% {
  opacity: 1;
}
`;
exports.StatusPlaceholder = styled_components_1.default.div `
  width: 0.5em;
  height: 0.5em;
  border: none;
  border-radius: 50%;
  margin-left: 0.5em;
  background: ${colors_1.default.text.primary};
  animation: ${exports.fadeIn} 1s infinite;
`;
exports.StatusIndicator = styled_components_1.default(exports.StatusPlaceholder) `
  animation: none;
  background: ${(props) => props.type === constants_1.EXECUTION_STATUS.SUCCESS
    ? colors_1.default.palette.success
    : props.type === constants_1.EXECUTION_STATUS.FAILED
        ? colors_1.default.palette.error
        : colors_1.default.text.secondary};
`;
exports.StyledInput = styled_components_1.default.input `
  background: transparent;
  padding-left: 0.5em;
  box-sizing: border-box;
  border-radius: 0 0.25em 0.25em 0;
  font-size: ${(props) => props.fontSize || '1.2em'};
  height: ${(props) => props.height || '3em'};
  width: 18em;
  border: solid 0.08em ${(props) => props.borderColor || '#cad1d7'};
  color: #5e72e4;
  border-left: 0;
  outline: none;

  ::placeholder {
    color: ${colors_1.default.border.normal};
  }
`;
exports.OptionsWrapper = styled_components_1.default.ul `
  padding: 0.5em 0;
  background: #fff;
  width: 8em;
  font-size: 0.95vw;
`;
exports.OptionItem = styled_components_1.default.li `
  list-style: none;
  color: ${colors_1.default.text.secondary};
  cursor: pointer;
  padding: 0.5em;
  &:hover {
    background: #ccc;
  }
`;
exports.WorkflowTitle = styled_components_1.default.span `
  font-size: 1.1em !important;
`;
exports.WorkflowExecutionStatusIcon = styled_components_1.default.i `
  color: ${(props) => props.color || colors_1.default.palette.green};
  font-size: 1.2em !important;
`;
// font-family: 'proxima-nova', sans-serif;
exports.WorkflowExecutionStatus = styled_components_1.default.span `
  font-size: 1.1em;
  color: ${(props) => props.color || colors_1.default.text.secPrimary};
`;
exports.StyledOptionCol = styled_components_1.default(reactstrap_1.Col) `
  font-size: 1.2em;

  i {
    // -webkit-text-stroke: 0.08em #f5f6fa;
    color: #1d8cf8;
    cursor: pointer;
  }
`;
exports.StyledCustomDropDown = styled_components_1.default(drop_down_component_1.default) `
  .custom-dropdown-title {
    text-decoration: none !important;
  }
  .custom-dropdown-title:hover {
  }
`;
exports.SwitchStatus = styled_components_1.default.div `
  color: #212529;
`;
//# sourceMappingURL=StatusIndicator.js.map